import {
    GET_CONFIG_FORM28,    
    GET_COMBO_ZONAS,
    GET_DATOS_GRILLA_RESPONSABLE,
    GET_DATOS_GESTION_CASO,
    POST_ASIGNAR_RESPONSABLE,
    GET_COMBO_TIPO_NOTIFICA
} from '../types';

export default function ReasignarResponsableReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM28:
            return { ...state, cfg_form28:action.payload }
        case GET_COMBO_ZONAS:
            return { ...state, comboZonas:action.payload }
        case GET_DATOS_GRILLA_RESPONSABLE:
            return { ...state, datosGrilla:action.payload }
        case GET_DATOS_GESTION_CASO:
            return { ...state, datosGestionCaso:action.payload }
        case POST_ASIGNAR_RESPONSABLE:
            return { ...state, respuestaAsignar:action.payload }
        case GET_COMBO_TIPO_NOTIFICA:
            return { ...state, tiposNotificaSiniestro:action.payload }
       
       
        default:
            return state
    }
}